namespace app.model.monitoring {
  export interface IMonitorable {
    job?: app.model.job.IJob;
    id?: string;
  }

  export interface IMonitorableResource<T extends IMonitorable> extends IMonitorable, angular.resource.IResource<T> {
  }
}
